import {Component, OnInit} from '@angular/core';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';

import {ConfigurationService} from '../../pages-services';

@Component({
    selector: 'app-import-button',
    templateUrl: 'import-button.component.html',
    styleUrls: ['import-button.component.scss']
})
export class ImportButtonComponent implements OnInit {
    isUploading;

    constructor(private toasterService: ToasterService,
                private translateService: TranslateService,
                private configurationService: ConfigurationService) {
    }

    ngOnInit() {
    }

    fileUpload({target}) {
        this.isUploading = true;
        const fileField = target;
        const file = fileField.files[0];
        const reader = new FileReader();
        reader.onload = () => {
            const result = JSON.parse(reader.result);
            this.configurationService.uploadImport(result).subscribe(async (response) => {
                this.isUploading = false;
                if (response.success) {
                    const successMessage = await this.translateService.get('webpanel.products.import.success_message').toPromise();
                    this.toasterService.pop('success', '', successMessage);
                } else {
                    const errorMessage = await this.translateService.get('webpanel.products.import.error_message').toPromise();
                    this.toasterService.pop('error', '', errorMessage);
                }
                fileField.value = '';
            });
        };
        reader.readAsText(file);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/import-button/import-button.component.ts